/* eslint-disable @typescript-eslint/naming-convention */
import type { Func } from "@react-awesome-query-builder/core";

const UNIFIED_DAYS_BETWEEN: Func = {
  label: "DAYS TILL DATE",
  returnType: "number",

  // Custom jsonLogic builder
  jsonLogic: (args) => ({
    UNIFIED_DAYS_BETWEEN: [
      args.date, // user-selected value / field / func
      { var: "Start_Unified_Sync_Time" }, // injected field
    ],
  }),

  sqlFunc: "UNIFIED_DAYS_BETWEEN",

  args: {
    date: {
      label: "From Date",
      type: "date",
      valueSources: ["value", "field", "func"],
    },
  },

  formatFunc: (formattedArgs) =>
    `UNIFIED_DAYS_BETWEEN(${formattedArgs.date}, Start_Unified_Sync_Time)`,

  sqlFormatFunc: (formattedArgs) =>
    `UNIFIED_DAYS_BETWEEN(${formattedArgs.date}, Start_Unified_Sync_Time)`,
};

export default UNIFIED_DAYS_BETWEEN;
